export const ICON_FROM_IMAGE = {
    "bacteria.png": "majesticons:covid",
}
